import { Box, CardMedia, Divider, Icon, Typography, useMediaQuery } from '@mui/material'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import AdxEmptyState from 'components/reusable/emptyState/AdxEmptyState'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import React, { useState } from 'react'

const ProgressionDrawer = ({ drawerState, handleDrawer, data }) => {
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))
  const progressionTabs = ['Progress & Scores', 'Assignment Submissions']
  const [activeTab, setActiveTab] = useState(0)

  const CustomHeader = () => (
    <Box sx={{ padding: '16px 32px', display: 'flex', alignItems: 'center', gap: '16px' }}>
      <Typography>Enrolled Courses</Typography>
    </Box>
  )

  const roundNumber = (num) => {
    if (num) {
      return Math.round(num)
    } else return 0
  }

  return (
    <AdxDrawerComponent
      state={drawerState}
      anchor="right"
      onClose={handleDrawer}
      sx={{ padding: 0 }}
      sxIcon={{ marginRight: '32px' }}
      headerprops={<CustomHeader />}
    >
      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: isLarge ? 'flex-start' : 'center',
            paddingX: '30px',
            borderBlock: isLarge ? '1px solid #E5E5E5' : null,
            borderTop: isLarge ? null : '1px solid #E5E5E5',
          }}
        >
          {progressionTabs.map((tab, index) => {
            const isActive = index === activeTab

            return (
              <Box
                key={index}
                onClick={() => setActiveTab(index)}
                sx={{
                  textAlign: 'center',
                  padding: isLarge ? '0 16px' : '12px 16px',
                  height: isLarge ? '45px' : null,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  color: isActive ? 'alternate.main' : '',
                  borderTop: '2px solid transparent',
                  borderBottom: isActive ? '2px solid #09A3A9' : '2px solid transparent',
                }}
              >
                <Typography>{tab}</Typography>
              </Box>
            )
          })}
        </Box>

        {/* Header */}
        {!isLarge && (
          <Box
            sx={{
              margin: '20px 16px 0 16px',
              padding: '20px 16px',
              border: '1px solid #E5E5E5',
              borderRadius: '4.5px',
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
            }}
          >
            {data?.course_logo ? (
              <CardMedia
                component="img"
                sx={{
                  height: 45,
                  width: 45,
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
                src={data?.course_logo}
              />
            ) : (
              <Box
                width={45}
                height={45}
                borderRadius="50%"
                bgcolor="alternate.light"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon
                  sx={{
                    color: 'alternate.main',
                  }}
                >
                  text_snippet
                </Icon>
              </Box>
            )}

            <Typography>{data?.course_name}</Typography>
          </Box>
        )}

        {/* Score */}
        {activeTab === 0 && (
          <Box
            sx={{
              padding: isLarge ? '32px 30px' : '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <Typography sx={{ color: 'light-gray-text.main' }}>Score Breakdown</Typography>
            <Box
              display="flex"
              alignItems="center"
              padding="16px"
              borderRadius="4.5px"
              border="1px solid #E5E5E5"
            >
              <Box>
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="alternate.light"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon
                    sx={{
                      color: 'alternate.main',
                    }}
                  >
                    watch_later
                  </Icon>
                </Box>
              </Box>
              <Box width="100%" display="flex" flexDirection="column" gap="8px">
                <Typography>Attendance</Typography>
                <Box width="100%" display="flex" alignItems="center" gap="8px">
                  <Box
                    sx={{
                      width: '100%',
                      position: 'relative',
                      height: '10px',
                      backgroundColor: 'gray-background.main',
                      borderRadius: '4.5px',
                    }}
                  >
                    <Box
                      sx={{
                        width: `${roundNumber(data?.progress?.attendance)}%`,
                        position: 'absolute',
                        height: '100%',
                        backgroundColor: 'alternate.main',
                        borderRadius: '4.5px',
                      }}
                    ></Box>
                  </Box>
                  <Typography variant="subtitle1" color="alternate.main">
                    {roundNumber(data?.progress?.attendance)}%
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              padding="16px"
              borderRadius="4.5px"
              border="1px solid #E5E5E5"
            >
              <Box>
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="alternate.light"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon
                    sx={{
                      color: 'alternate.main',
                    }}
                  >
                    assignment
                  </Icon>
                </Box>
              </Box>
              <Box width="100%" display="flex" flexDirection="column" gap="8px">
                <Typography>Assignment</Typography>
                <Box width="100%" display="flex" alignItems="center" gap="8px">
                  <Box
                    sx={{
                      width: '100%',
                      position: 'relative',
                      height: '10px',
                      backgroundColor: 'gray-background.main',
                      borderRadius: '4.5px',
                    }}
                  >
                    <Box
                      sx={{
                        width: `${roundNumber(data?.progress?.assignment)}%`,
                        position: 'absolute',
                        height: '100%',
                        backgroundColor: 'alternate.main',
                        borderRadius: '4.5px',
                      }}
                    ></Box>
                  </Box>
                  <Typography variant="subtitle1" color="alternate.main">
                    {roundNumber(data?.progress?.assignment)}%
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        {/* Submission */}
        {activeTab === 1 && (
          <Box
            sx={{
              padding: isLarge ? '32px 30px' : '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            {data?.assignment_submission?.length > 0 ? (
              data?.assignment_submission?.map((item, index) => (
                <Box>
                  <Typography sx={{ color: 'light-gray-text.main', marginBottom: '16px' }}>
                    Week {index + 1}
                  </Typography>
                  <Box
                    sx={{
                      height: '40px',
                      borderRadius: '4.5px',
                      border: '1px solid #E5E5E5',
                      display: 'flex',
                      paddingX: '16px',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                      {item?.link ?? '-'}
                    </Typography>
                  </Box>
                </Box>
              ))
            ) : (
              <AdxEmptyStateV2 icon="error" message="No submission found" />
            )}
          </Box>
        )}
      </Box>
    </AdxDrawerComponent>
  )
}

export default ProgressionDrawer
